// eslint-disable-next-line no-restricted-imports
import * as sessionReplay from "@amplitude/session-replay-browser"

import { DeviceIDService } from "src/utils/DeviceIDService"
import { SessionService } from "src/utils/SessionService"
/**
 * Initializes the Amplitude session replay tracking.
 * This function:
 * 1. Gets the Amplitude API key from environment variables
 * 2. Initializes session replay with:
 *    - The current device ID for tracking across sessions
 *    - The current session ID for tracking within a session
 *    - 100% sample rate to capture all sessions
 *    - Debug mode enabled for development
 */
function init() {
  const apiKey = import.meta.env.REACT_APP_AMPLITUDE_API_KEY

  sessionReplay.init(apiKey, {
    deviceId: DeviceIDService.getId(),
    sessionId: SessionService.retrieve(),
    sampleRate: 0.4,
  })
}

/**
 * Gets the session recording properties for analytics events.
 * This function:
 * 1. Retrieves the current session ID
 * 2. Updates the session replay tracker with the current session ID
 * 3. Returns the session replay properties to be included in analytics events
 *
 * @returns The session replay properties from Amplitude's session replay tracker
 */
function getSessionRecordingEventProperties() {
  const sessionId = SessionService.retrieve()

  sessionReplay.setSessionId(sessionId)

  return sessionReplay.getSessionReplayProperties()
}

/**
 * SessionRecordingService is a service that handles the session recording for the web app.
 *
 * A session recording is a recording of a user's interaction with the web app.
 *
 */
export const SessionRecordingService = {
  init,
  getSessionRecordingEventProperties,
}
